import { render, staticRenderFns } from "./Pos_Search_Items.vue?vue&type=template&id=0b5b616c&"
import script from "./Pos_Search_Items.vue?vue&type=script&lang=js&"
export * from "./Pos_Search_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports